export default "__VITE_ASSET__7YDGJry4__"